import React from "react";
import ParentComponent from "../../lib/ParentComponent";
import Loading from "../../lib/Loading";
import firebase, {
  auth,
  facebookProvider,
  googleProvider,
} from "../../lib/firebase";
import ar from "../../locale";

export default class Login extends ParentComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  showLoading = (show) => {
    this.state.loading = show;
    this.updateState();
  };

  loginUsingEmail = (e) => {
    e.preventDefault();
    this.showLoading(true);
    var email = this.email.value;
    var password = this.password.value;
    auth
      .signInWithEmailAndPassword(email, password)
      .then((result) => {
        this.checkAdmin(result);
      })
      .catch((error) => {
        console.log("error -> ", error);
        this.showLoading(false);
        this.showError(error.message);
      });
  };

  loginUsingGoogle = (e) => {
    this.showLoading(true);
    auth.languageCode = "ar";
    auth
      .signInWithPopup(googleProvider)
      .then((result) => {
        this.checkAdmin(result);
      })
      .catch((error) => {
        this.showLoading(false);
        this.showError(error.message);
      });
  };

  loginUsingFacebook = (e) => {
    this.showLoading(true);
    facebookProvider.addScope("email");
    auth.languageCode = "ar";
    auth
      .signInWithPopup(facebookProvider)
      .then((result) => {
        this.checkAdmin(result);
      })
      .catch((error) => {
        this.showLoading(false);
        this.showError(error.message);
      });
  };

  checkAdmin = (result) => {
    let uid = result.user.uid;
    let adminRef = firebase.database().ref("admin_users/").once("value");
    let userRef = firebase
      .database()
      .ref("users/" + uid)
      .once("value");
    Promise.all([adminRef, userRef])
      .then((resArr) => {
        let adminVal = resArr[0].val();
        let userVal = resArr[1].val();
        if (userVal && adminVal && adminVal[uid]) {
          this.showLoading(false);
          this.props.history.push("/");
        } else {
          throw new Error("User not found");
        }
      })
      .catch((error) => {
        this.showLoading(false);
        this.showError(error.message);
      });
  };

  showError = (message) => {
    window.toastr.error(message, "Invalid Credentials", {
      positionClass: "toastr toast-top-center",
    });
  };

  render() {
    return (
      <>
        <div className="main-wrapper login-back">
          <div className="auth-wrapper d-flex no-block justify-content-center align-items-center">
            <div className="auth-box">
              <div id="loginform">
                <div className="logo">
                  <h5 className="font-medium m-b-20">
                    {ar.login_to_your_account}
                  </h5>
                </div>

                <div className="row">
                  <div className="col-12">
                    <form
                      className="form-horizontal m-t-20"
                      id="loginform"
                      onSubmit={this.loginUsingEmail}
                    >
                      <div className="input-group mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text" id="basic-addon1">
                            <i className="ti-user"></i>
                          </span>
                        </div>
                        <input
                          type="email"
                          ref={(ele) => (this.email = ele)}
                          className="form-control form-control-lg"
                          placeholder={ar.enter_your_email}
                          aria-label="Username"
                          aria-describedby="basic-addon1"
                          required
                        />
                      </div>
                      <div className="input-group mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text" id="basic-addon2">
                            <i className="ti-pencil"></i>
                          </span>
                        </div>
                        <input
                          type="password"
                          ref={(ele) => (this.password = ele)}
                          className="form-control form-control-lg"
                          placeholder={ar.enter_your_password}
                          aria-label="Password"
                          aria-describedby="basic-addon1"
                          required
                        />
                      </div>
                      <div className="form-group text-center">
                        <div className="col-xs-12 p-b-20">
                          <button
                            className="btn btn-block btn-lg btn-info"
                            type="submit"
                          >
                            {ar.sign_in}
                          </button>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 m-t-10 text-center">
                          <div className="social">
                            <button
                              type="button"
                              onClick={this.loginUsingFacebook}
                              className="btn  btn-facebook"
                              data-toggle="tooltip"
                              title=""
                              data-original-title="Login with Facebook"
                            >
                              {" "}
                              <i
                                aria-hidden="true"
                                className="fab  fa-facebook"
                              ></i>{" "}
                            </button>
                            &nbsp;&nbsp;
                            <button
                              type="button"
                              onClick={this.loginUsingGoogle}
                              className="btn btn-googleplus"
                              data-toggle="tooltip"
                              title=""
                              data-original-title="Login with Google"
                            >
                              {" "}
                              <i
                                aria-hidden="true"
                                className="fab  fa-google-plus"
                              ></i>{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Loading show={this.state.loading} />
      </>
    );
  }
}
